import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { APPLICATION_VALUES } from './app.constants';
import { LangUpdateService } from './_services/lang-update.service';
import { REPORT_TEMPLATE___APPLICATION_TYPE, StorageService } from './_services/storage.service';
import { SpinnerService } from '@osc-utils/services/spinner.service';
import { AppIdentity, Guid, PlatformService } from '@evc/platform';
import { BtnActionEnum, MenuItemType } from '@evc/web-components';
import { RtbAuthService } from './auth/rtb-auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  private isVisol = !!this.storageService.fetchApplicationType(REPORT_TEMPLATE___APPLICATION_TYPE)?.IsVisol;
  public appIdentification: AppIdentity = {
    title: 'Report Template Builder',
    name: 'Report Template Builder',
    version: APPLICATION_VALUES.VERSION,
    onTitleClick: () => this.router.navigateByUrl('/template-list'),
  };
  public settingsMenu = this.isVisol ? [
    {
      key: 'language',
      text: this.translate.stream('app.language'),
      collapsible: [
        {
          key: 'en',
          text: 'English',
          action: {
            type: BtnActionEnum.CALLBACK,
            callbackOrUrl: () => this.langService.updateLanguage('en'),
          },
        },
        {
          key: 'zh',
          text: '中文',
          action: {
            type: BtnActionEnum.CALLBACK,
            callbackOrUrl: () => this.langService.updateLanguage('zh'),
          },
        }
      ],
    }
  ] as MenuItemType[] : [];
  public ready = this.platformService.ready;
  public readonly onOrganizationChanging = (organizationId: Guid) => {
    // Resources are organization specific. Therefore, we need to redirect the user back to the home page to prevent access issues.
    return this.rtbAuthService.login({
      extraQueryParameters: { toid: organizationId },
      redirectUri: '/',
      redirectStartPage: '/template-list',
    });
  }

  public constructor(
    private rtbAuthService: RtbAuthService,
    public spinnerService: SpinnerService,
    private router: Router,
    private translate: TranslateService,
    private langService: LangUpdateService,
    private storageService: StorageService,
    private platformService: PlatformService
  ) {
    this.langService.updateLanguage(this.translate.getBrowserLang());
  }

  public ngAfterViewInit(): void {
    document.body.style.minWidth = 'unset';
  }

  public onLogout() {
    this.rtbAuthService.logout();
  }
}
